<template>
  <div class="container">
    <div class="content">
      <!--<div class="top">-->
      <div style="text-align:center;">
        <div>
          <!-- <img alt="logo" class="logo" src="/static/img/logo.png"> -->
          <img class="titlePng" src="/static/img/login_title.png">
          <!-- <span class="title">{{ systemName }}</span> -->
          <component :is="componentName" class="main-content" style="margin-top: 40px" @regist="handleRegist" />
        </div>
        <!--        <div class="desc"></div>-->
        <!--      </div>-->
      </div>
    </div>
    <global-footer :copyright="copyright" />
  </div>
</template>

<script>
import GlobalFooter from '../common/GlobalFooter'
import Login from './Login'

export default {
  name: 'Common',
  components: { GlobalFooter, Login },
  data () {
    return {
      componentName: 'Login'
    }
  },
  computed: {
    systemName () {
      return this.$store.state.setting.systemName
    },
    copyright () {
      return this.$store.state.setting.copyright
    }
  },
  methods: {
    handleRegist (val) {
      this.componentName = val
    }
  }
}
</script>
<style lang="less" scoped>
  .container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-width: 1920px;
    background-size: 100% 100%;
    background-image: url('/static/img/loginBg.jpg');
    background-repeat: no-repeat;
    position: relative;
    .content {
      position: absolute;
      top: 34%;
      left: 54%;
      flex: 1;
      @media (min-width: 768px) {
        // padding: 8rem 0rem;
      }
    }
  }
      .logo {
        width: 40px;
        height: 40px;
        vertical-align: center;
        margin-right: 16px;
      }
      .titlePng{
        width: 150px;
        height: 34px;
      }
      .title {
        font-size: 28px;
        color: rgba(0,0,0,.85);
        font-family: 'Myriad Pro', 'Helvetica Neue', Arial, Helvetica, sans-serif;
        font-weight: 600;
        position: relative;
        top: 6px;
      }
      /*.top {*/
      /*  text-align: center;*/
      /*  background-color: white;*/
      /*  .header {*/
      /*    height: 50px;*/
      /*    line-height: 50px;*/
      /*    a {*/
      /*      text-decoration: none;*/
      /*    }*/
      /*    .logo {*/
      /*      width: 40px;*/
      /*      height: 19px;*/
      /*      vertical-align: center;*/
      /*      margin-right: 16px;*/
      /*    }*/
      /*    .title {*/
      /*      font-size: 28px;*/
      /*      color: rgba(0,0,0,.85);*/
      /*      font-family: 'Myriad Pro', 'Helvetica Neue', Arial, Helvetica, sans-serif;*/
      /*      font-weight: 600;*/
      /*      position: relative;*/
      /*      top: 6px;*/
      /*    }*/
      /*  }*/
      /*  .desc {*/
      /*    font-size: 14px;*/
      /*    color: rgba(0,0,0,.45);*/
      /*    margin-top: 12px;*/
      /*    margin-bottom: 40px;*/
      /*  }*/
      /*}*/
      /*.main-content {*/
      /*  width: 368px;*/
      /*  margin: 0 auto;*/
        /*@media screen and (max-width: 576px) {*/
        /*  width: 95%;*/
        /*}*/
        /*@media screen and (max-width: 320px) {*/
        /*  .captcha-button{*/
        /*    font-size: 14px;*/
        /*  }*/
        /*}*/
      /*}*/
    /*}*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/views/login/Common.vue